import i18n from 'i18next';
import HttpApi from 'i18next-http-backend';
import { initReactI18next } from 'react-i18next';

import { APP_CONST } from '@/constant';
import { storage } from '@vueron/kiska';

(async () => {
  if (import.meta.env.MODE === 'test') return;

  i18n
    .use(initReactI18next)
    .use(HttpApi)
    .init({
      fallbackLng: APP_CONST.LANG.EN,
      ns: ['translation'],
      defaultNS: 'translation',
      fallbackNS: 'translation',
      backend: {
        loadPath: `${import.meta.env.BASE_URL}locales/{{lng}}/{{ns}}.json`,
      },
      keySeparator: '.',
      interpolation: {
        escapeValue: false,
      },
      supportedLngs: Object.values(APP_CONST.LANG),
    });

  // 저장된 언어(STORAGE_LANG)를 부팅 시점부터 적용해, langStore 가 로드되기
  // 전에 렌더되는 초기 로딩 UI 가 영어로 표시되지 않게 합니다.
  const storedLang =
    storage.local.get<APP_CONST.LANG | string>(APP_CONST.KEYS.STORAGE_LANG) ??
    APP_CONST.LANG.EN;

  await i18n.changeLanguage(storedLang);
})();

export default i18n;
